export const filterItems = (array, key) => {
  let items = array.reduce(function (accumlator, current) {
    if (current[key] === undefined) {
      accumlator["other"] = accumlator["other"] || { name: "OTHER", val: [] };
      accumlator["other"].val = [...accumlator["other"].val, current];
    } else {
      accumlator[current[key]] = accumlator[current[key]] || {
        name: current[key].replace("_", " ").toUpperCase(),
        val: [],
      };
      accumlator[current[key]].val = [...accumlator[current[key]].val, current];
    }
    return accumlator;
  }, Object.create(null));
  return items;
};

export const filterNeutralItems = (array) => {
  let items = {};
  for (let i = 1; i < 6; i++) {
    let lvlName = `tier ${i}`;
    items[lvlName] = {};
    items[lvlName].name = lvlName.toUpperCase();
    items[lvlName].val = array.filter((item) => {
      return item.tier === i;
    });
  }
  return items;
};
